module.exports = "https://web-assets-production.autolist.com/_next/static/images/carfax-189055e7cd22ac1c1fff434f2bca0729.svg";